var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 864,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 865,
	"./assets/thewest-digital-hero-variation-a.jpg": 2964,
	"./assets/thewest-digital-hero-variation-afl50-mobile.jpg": 866,
	"./assets/thewest-digital-hero-variation-afl50.jpg": 2965,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 867,
	"./assets/thewest-digital-hero-variation-b.jpg": 2966,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 868,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2967,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 869,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2968,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 870,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2969,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 871,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2970,
	"./assets/thewest-digital-hero.jpg": 2971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 863;